import * as React from 'react';

import { type FileLocation, uploadFile } from '@gitbook/app-database';
import { type FilesDropZoneAccept, type ToastPromiseData, toast } from '@gitbook/spine-react';

import { promptFile } from './promptFile';

/**
 * Return a callback to prompt the user to select a file and upload it.
 */
export function useUploadFile() {
    /**
     * Prompt user to select file, then upload them.
     */
    const promptAndUpload = React.useCallback(
        async (
            location: FileLocation & { accept?: FilesDropZoneAccept },
            toastInfos: Pick<ToastPromiseData, 'loading' | 'success'> = {
                loading: 'Uploading files…',
                success: 'Files uploaded',
            }
        ) => {
            const [file] = await promptFile({ accept: location.accept });

            if (!file) {
                return;
            }

            const promise = uploadFile(location, file);
            toast.promise(promise, {
                loading: toastInfos.loading,
                success: toastInfos.success,
                error: 'Error while uploading your files',
            });
            return promise;
        },
        []
    );

    return promptAndUpload;
}
